import { render, staticRenderFns } from "./InventoryReservationForm.vue?vue&type=template&id=c970865a"
import script from "./InventoryReservationForm.vue?vue&type=script&lang=js"
export * from "./InventoryReservationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c970865a')) {
      api.createRecord('c970865a', component.options)
    } else {
      api.reload('c970865a', component.options)
    }
    module.hot.accept("./InventoryReservationForm.vue?vue&type=template&id=c970865a", function () {
      api.rerender('c970865a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryReservation/InventoryReservationForm.vue"
export default component.exports